import { render, staticRenderFns } from "./LanguagesDialog.vue?vue&type=template&id=27294b4a&scoped=true&lang=pug&"
import script from "./LanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./LanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LanguagesDialog.vue?vue&type=style&index=0&id=27294b4a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27294b4a",
  null
  
)

export default component.exports